"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LightClientRPC = exports.FetchFlag = void 0;
let FetchFlag = /*#__PURE__*/function (FetchFlag) {
  FetchFlag["Fetched"] = "fetched";
  FetchFlag["Fetching"] = "fetching";
  FetchFlag["Added"] = "added";
  FetchFlag["NotFound"] = "not_found";
  return FetchFlag;
}({});
exports.FetchFlag = FetchFlag;
/* eslint-disable  @typescript-eslint/no-namespace */
let LightClientRPC;
exports.LightClientRPC = LightClientRPC;
(function (_LightClientRPC) {})(LightClientRPC || (exports.LightClientRPC = LightClientRPC = {}));
//# sourceMappingURL=type.js.map